import React from 'react';
import styled from 'styled-components';
import TextBlock from '@component/common/block/text-block';
import Gap from '@component/common/gap';
import TextButton from '@design-system/text-button';
import { ETheme } from '@datatype/type';
import * as color from '@constant/color';
import * as size from '@constant/size';

interface IProps {
  title: string;
  input: React.ReactNode;
  errorMessage?: string;
  isPending: boolean;
  saveDisabled?: boolean;
  width?: string;
  handleCancel: () => void;
  handleSave: () => void;
}

const Wrapper = styled.div<{ $width: string }>`
  display: flex;
  width: ${({ $width }) => $width};
  flex-direction: column;
`;

const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  gap: ${size.MARGIN_1};
`;

const EditModalTemplate: React.FC<IProps> = ({
  title,
  input,
  errorMessage,
  isPending,
  saveDisabled = false,
  width = size.MEDIUM_MODAL_WIDTH,
  handleCancel,
  handleSave,
}) => (
  <Wrapper $width={width}>
    <TextBlock text={title} design={{ text: { size: 'large', color: color.BLACK_2, bold: true } }} />
    <Gap height={size.MARGIN_2} />
    {input}
    {errorMessage && (
      <>
        <Gap height={size.MARGIN_1} />
        <TextBlock text={errorMessage} design={{ text: { size: 'small', color: color.RED_2 } }} />
      </>
    )}
    <Gap height={size.MARGIN_2} />
    <ButtonContainer>
      <TextButton
        text='취소'
        theme={ETheme.GRAY}
        kind='outlined'
        size='medium'
        shape='pill'
        width='100%'
        disabled={isPending}
        handleClick={handleCancel}
      />
      <TextButton
        text='저장'
        theme={ETheme.CYAN}
        size='medium'
        shape='pill'
        width='100%'
        disabled={saveDisabled || isPending}
        isLoading={isPending}
        handleClick={handleSave}
      />
    </ButtonContainer>
  </Wrapper>
);

export default EditModalTemplate;
